import { BasePermission, BasePermissionV2 } from '../dto/userGroupsDto';

export const isOldPermission = (permission: BasePermission | BasePermissionV2) => {
  if (permission.activity) return true;
  return false;
};
